import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({
	many: "course_items"
})
export default class CourseItem {

	@Field()
	public entryId: number;

	@Field()
	public title: string;

	@Field()
	public iconUrl: string;

	//@Field()
	//public description: string;

	@Field()
	public launchUrl: string;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/CourseItem.ts